// /config/api/user.js
import CONFIG from "@/config/config";
import request from "@/config/request";
import store from "@/store";
import {getCurrentBalance} from "@/config/api/blockchain"

/**
 * 判断是否注册/授权
 * @param {adress: address, type: type链类型} data 
 * @returns 
 */
export function isRegister(data = {}) {
    return request.post(`${CONFIG.BASE_URL}/api/index/isRegister`, data)
}

/**
 * 获取到users表中的授权信息，并且设置state
 * @param {address: address} data 
 * @returns 
 */
export async function info(data) {
    try {
        // 调用 info 接口： 后端获取不到balance的时候会异常
        //const response = await request.post(`${CONFIG.BASE_URL}/api/index/addyue`, data);
        // if (response.status === 200) {
        //     const users = response.data; //注意这个接口是以前的接口，后端返回结构不是标准的
        //     store.commit('setUsers', users);
        // }

        // 调用 info 接口 V2优化：不会出异常，但是可能获取不到的users.balance，解决方案可以考虑前端获取
        const response = await request.postNoLoading(`${CONFIG.BASE_URL}/api/users/info`, data);
        if (response.status === 200) {
            if (response.data.code === 1) {
                const users = response.data.data; 
                store.commit('setUsers', users);
            } else {
                store.commit('setUsers', {});
                console.log('invalid users'); 
            }
        }

        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error fetching user info:", error);
        throw error;
    } finally {
        // 无论如何都尝试更新当前余额
        await getCurrentBalance();
    }
}

/**
 * 授权合约后注册登录
 * @param data {
        address: address, //钱包地址
        type: type, // 链类型
        yue: 1, 
        c: invite_code, //邀请码
        balance: balance, // 钱包余额
    }  
 * @returns 
 */
export async function signin(data = {}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/index/login`, data);

        if (response.status === 200) {
            store.commit('setState', {key: 'token', value: '1'});
        }
        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error signin:", error);
        throw error;
    }
}


/**
 * 质押申请
 * @param {*} data 
 * @returns 
 */
export function apply(data = {}) {
    return request.post(`${CONFIG.BASE_URL}/api/users/apply`, data)
}
// ui2 模式业务逻辑有些不一样，重新写一个接口实现挖矿申请（设置流动矿机级别）
export function miningSet(data={}) {
    return request.post(`${CONFIG.BASE_URL}/api/users/miningSet`, data)
}
// ui2 模式业务逻辑有些不一样，重新写一个接口实现挖矿申请（设置质押级别）
export function pledgeSet(data={}) {
    return request.post(`${CONFIG.BASE_URL}/api/users/pledgeSet`, data)
}
// ui2 模式业务逻辑有些不一样，重新写一个接口实现质押申请
export function pledgeApply(data={}) {
    return request.post(`${CONFIG.BASE_URL}/api/users/pledgeApply`, data)
}

/**
 * 撤回质押申请
 * @param {*} data 
 * @returns 
 */
export function unpledge(data = {}) {
    return request.post(`${CONFIG.BASE_URL}/api/users/unpledge`, data)
}


/**
 * 提息申请
 * @param {*} data 
 * @returns 
 */
export async function withdrawal(data = {}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/withdrawal`, data);

        // if (response.status === 200) {
        //     const result = response.data;
        // }
        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error signin:", error);
        throw error;
    }
}

/**
 * 获取用户最近10条派息记录
 * @param {*} data 
 * @returns 
 */
export async function earningList(data={}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/earning_list`, data);

        // if (response.status === 200) {
        //     const result = response.data;
        // }
        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error earningList:", error);
        throw error;
    }
}

/**
 * 获取用户最近10条提利息/提质押记录
 * @param {*} data 
 * @returns 
 */
export async function withdrawList(data={}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/withdraw_list`, data);

        // if (response.status === 200) {
        //     const result = response.data;
        // }
        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error withdrawList:", error);
        throw error;
    }
}

/**
 * 获取预期收益
 * @param {*} data 
 * @returns 
 */
export async function expectedIncome(data={}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/expectedIncome`, data);
        // console.log("expectedIncome response:", response);
        if (response.status === 200 && response.data.code === 1) {
            const result = response.data.data.data; // 注意这个接口是以前的接口，后端返回结构不是标准的
            const expected = {
                pledge_income: result.pledge_income || 0, // 质押收益
                liquid_income: result.liquid_income || 0, // 流动性收益
            };
            store.commit('setState', {key: 'expected', value: expected});
        }
        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error expectedIncome:", error);
        throw error;
    }
}

/**
 * @FIXME 邀请情况-概况
 * @param {*} data 
 * @returns {}
 */
export async function invitation(data = {}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/invitation`, data);

        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error invitation:", error);
        throw error;
    }
}
/**
 * @FIXME 邀请情况-邀请列表
 * @param {*} data 
 * @returns {}
 */
export async function invitation_list(data = {}) {
    try {
        const response = await request.post(`${CONFIG.BASE_URL}/api/users/invitation_list`, data);

        return response; // 返回结果，便于其他地方使用
    } catch (error) {
        console.error("Error invitation:", error);
        throw error;
    }
}


/**
 * @FIXME 我的投资收益情况
 * @param {*} data 
 * @returns {}
 */
export async function mining(data = {}) {
    // 模拟异步操作，使用 Promise 来包装结果
    return new Promise((resolve) => {
        let result = {
            status: 200,
            data: {
            }
        };
        resolve(result); // 可使用setTimeout后resole，模拟异步返回
    });
}

/**
 * 获取公告数据,和index/announcement接口有些不一样，增加了用户判断
 * @param {} data 
 * @returns 
 */
export async function gongao(data = {}) {
    try {
        return await request.post(`${CONFIG.BASE_URL}/api/users/gongao`, data)
    } catch (error) {
        console.error("Error fetching announcement:", error);
        throw error;
    }
}
